// import { collection, addDoc } from "firebase/firestore";
// import { db } from "./firebase";
const hasUtmParams = (urlObj) =>
  [...urlObj?.searchParams.keys()].some((key) => key.startsWith("utm_"));

export const pageview = async (url) => {
  if (process.env.analyticsEnabled) {
    const measurementId = process.env.NEXT_PUBLIC_FIREBASE_MEASUREMENT_ID;
    if (typeof window !== "undefined" && window.gtag && measurementId) {
      window.gtag("config", measurementId, {
        page_path: url,
      });

      const urlObj = new URL(window.location.href);
      if (hasUtmParams(urlObj)) {
        const cleanUrl = urlObj.pathname + urlObj.hash;
        window.history.replaceState({}, "", cleanUrl);
      }
    }
  }

  // try {
  //   await addDoc(collection(db, "user_activity_logs"), {
  //     type: "pageview",
  //     url,
  //     timestamp: new Date().toISOString(),
  //   });
  // } catch (err) {
  // }
};

export const event = async ({ action, params }) => {
  if (typeof window !== "undefined" && window.gtag) {
    window.gtag("event", action, params);
  }

  // try {
  //   await addDoc(collection(db, "user_activity_logs"), {
  //     type: "event",
  //     action,
  //     params,
  //     // userId,
  //     timestamp: new Date().toISOString(),
  //   });
  // } catch (err) {
  // }
};
